// Navbar + MobileBottomNav.
export const nav: Record<string, string> = {
  // Markets
  'All Markets': 'Sva tržišta',
  'Forex': 'Forex',
  'Crypto': 'Kripto',
  'Stocks': 'Akcije',
  'Indices': 'Indeksi',
  'Commodities': 'Roba',
  'MARKETS': 'TRŽIŠTA',

  // Top navbar
  'Search tickers, traders…': 'Pretraži tikere, trejdere…',
  'Post Idea': 'Objavi ideju',
  'Messages': 'Poruke',
  'My Profile': 'Moj profil',
  'Followers & Following': 'Pratioci i praćenja',
  'Portfolio': 'Portfolio',
  'Leaderboard': 'Rang lista',
  'Trade Battles': 'Trejd bitke',
  'Watchlist': 'Lista praćenja',
  'Trader Channels': 'Kanali trejdera',
  'Live Chat': 'Ćaskanje uživo',
  'Academy': 'Akademija',
  'Trade studies': 'Studije trejdova',
  'Invite & Earn': 'Pozovi i zaradi',
  'Settings': 'Podešavanja',
  'Sign Out': 'Odjavi se',
  'Sign In': 'Prijavi se',
  'Sign Up': 'Registruj se',
  'Channels': 'Kanali',
  'Battles': 'Bitke',

  // Mobile bottom nav + drawer
  'Home': 'Početna',
  'Ranks': 'Rang',
  'Post': 'Objavi',
  'Alerts': 'Obaveštenja',
  'Menu': 'Meni',
  'Close menu': 'Zatvori meni',
  'Open menu': 'Otvori meni',
  'Post a trade': 'Objavi trejd',
  'Primary navigation': 'Glavna navigacija',
  'Trending Ideas': 'Ideje u trendu',
  'NEW': 'NOVO',
  'Open Trades': 'Otvoreni trejdovi',
  'Top Traders': 'Najbolji trejderi',
  'Verify account': 'Verifikuj nalog',
};
